'use strict';

import Vue from 'vue'
import API from '@/config/api'

export default class Commons {

    static handleApiError(el, error) {
        el.$message.error({
            showClose: true,
            message: error.toString()
        });
        console.error(error);
    }
    static getDomain() {
        var host = window.location.hostname;
        var ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;

        if (ip.test(host) === true || host === 'localhost') return host;

        var regex = /([^]*).*/;
        var match = host.match(regex);

        if (typeof match !== 'undefined' && match !== null) host = match[1];
        if (typeof host !== 'undefined' && host !== null) {
            var strAry = host.split('.');

            if (strAry.length > 1) {
                host = strAry[strAry.length - 2] + '.' + strAry[strAry.length - 1];
            }
        }
        return '.' + host;
    };

    static getAppIds(callback) {
        // if (API.APPID === "") {
            console.log('before commons getAppIds')
            Vue.http.post(API.APP_LIST2, { permissions: ['app_manager'], system: 'erf' })
                .then(resp => {
                    console.log(resp)
                    const data = resp.body
                    API.APPLIST = data.apps;
                    if (sessionStorage.getItem("currentApp") == null) {
                        API.APPID = API.APPLIST[0].appid;
                        API.APPNAME = API.APPLIST[0].name;
                        sessionStorage.setItem(
                            "currentApp",
                            JSON.stringify(API.APPLIST[0])
                        );
                    } else {
                        let temp = JSON.parse(sessionStorage.getItem("currentApp"));
                        let found = false
                        for (let i = 0; i < API.APPLIST.length; ++i) {
                            if (API.APPLIST[i].id === temp.id) {
                                API.APPID = temp.appid;
                                API.APPNAME = temp.name;
                                found = true
                                break;
                            }
                        }
                        if (!found) {
                            API.APPID = API.APPLIST[0].appid;
                            API.APPNAME = API.APPLIST[0].name;
                            sessionStorage.setItem(
                                "currentApp",
                                JSON.stringify(API.APPLIST[0])
                            );
                        }
                    }
                    console.log('after commons getAppIds')
                    console.log(data.apps)
                    callback()
                })
        // } else {
        //     callback()
        // }
    }


}




// WEBPACK FOOTER //
// ./src/config/commons.js